import {Component, NgZone, OnInit, Inject} from '@angular/core';
import {MDCTextField} from '@material/textfield';
import {AuthService} from '../services/auth.service';
import * as firebase from 'firebase';
import {Roles} from '../models/Roles';
import {Router} from '@angular/router';
import {MDCTextFieldHelperText} from '@material/textfield/helper-text';
import {FormControl} from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
@Component({
  selector: 'app-createpatient',
  templateUrl: './createpatient.component.html',
  styleUrls: ['./createpatient.component.css']
})
export class CreatepatientComponent implements OnInit {
  fname: string;
  lname: string;
  patientId: string;
  legalCaseId: string;
  errorMessage: string;
  date: FormControl = new FormControl();
  constructor(public auths: AuthService, public router: Router, public ng: NgZone, public dialog: MatDialog,
    public dialogRef: MatDialogRef<CreatepatientComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.fname = '';
    this.lname = '';
    this.patientId = '';
    this.legalCaseId = '';
    this.errorMessage = '';
  }

  ngOnInit() {
    this.authInit();
    this.initializeComponents();

    this.auths.errorAuth.subscribe((error) => {
      this.errorMessage = error;
    });
  }
  initializeComponents() {
    const firstName = new MDCTextField(document.querySelector('.fname'));
    const lastName = new MDCTextField(document.querySelector('.lname'));
    const patientIdQuery = new MDCTextField(document.querySelector('.patientID'));
    const helperText = new MDCTextFieldHelperText(document.querySelector('.mdc-text-field-helper-text'));
    const legalId = new MDCTextField(document.querySelector('.lcase'));
  }
  authInit() {
    this.auths.user.subscribe((user) => {
      if (user !== null && user !== undefined) {
        const db = firebase.firestore();
        db.collection('users').where('uid', '==', user.uid).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data()['role'] !== Roles.client && doc.data()['role'] !== Roles.clientAdmin) {
            this.determineRoute(doc.data()['role'], user);
            }
          });
        });
      }
    });
  }
  createPatient() {
    const dateValue = new Date(this.date.value);
    const dateString = dateValue.getDate().toString() + '/' + dateValue.getMonth().toString()  + '/'  + dateValue.getFullYear().toString();
    if (this.fname.trim() === '' || this.lname.trim() === '' || this.patientId.trim() === '' || this.legalCaseId.trim() === '') {
      this.auths.firePatientCantAdd();
    } else {
      this.auths.createPatient(this.fname.toLowerCase(), this.lname.toLowerCase(), this.patientId, this.legalCaseId, dateString);
    }
  }

  determineRoute(role: any, user: any) {
    if (role === Roles.consultant) {
      this.ng.run(() => this.router.navigateByUrl('search/' + user.uid + '/' + user.email + '/' + role));
    } else {
      this.ng.run(() => this.router.navigateByUrl('home'));
    }
  }

  goBack(){
    window.history.back();
  }



}
